import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import { Box,Stack,Typography } from '@mui/material';
import Signature,{ SignatureCanvasRef } from '@uiw/react-signature/canvas';
import { useContext,useEffect,useRef } from 'react';
import { WebFormContext } from '../../../../context/WebFormContext';
import { SubItemFormFilling } from '../../../../types/new-form-filling/types';
import CheckIcon from '../../CheckIcon';
import AdditionalInfo from '../../Structure/AdditionalInfo';

type props = {
  subitem: SubItemFormFilling,
  assinatura: string | null,
  setAssinatura: Function,
};

export default function Assinatura({
  assinatura,
  setAssinatura,
  subitem,
}: props) {
  const refAssinatura = useRef<SignatureCanvasRef | null>(null);
  const { ForceUpdate } = useContext(WebFormContext);

  const textFieldTitle: string = (() => {
    let title = '';
    if (CheckIcon(subitem, assinatura) === 'naoOk') {
      title += '* ';
    }
    title += `${subitem.id + 1} - ${subitem.nome}`;
    return title;
  })();

  const style = {
    width: navigator.maxTouchPoints > 0 ? '100%' : 400,
    bgcolor: 'inherit',
    border: '2px solid #D9D9DF',
    boxShadow: 24,
  };

  function handleSave() {
    setAssinatura(refAssinatura.current?.canvas?.toDataURL() ?? null);
  }

  function handleClear() {
    refAssinatura.current?.clear();
    setAssinatura(null);
    delete subitem.assinatura;
  }

  useEffect(() => {
    if (subitem.assinatura) {
      setAssinatura(subitem.assinatura);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (assinatura) {
      (subitem.assinatura as string | null) = assinatura;
    } if (CheckIcon(subitem, assinatura) === 'ok') {
      subitem.checked = true;
    } else {
      delete subitem.checked;
    }
    ForceUpdate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assinatura]);

  return (
    <>
      <Typography
        variant='h6'
        style={{
          wordBreak: 'break-all',
          marginBottom: '5px',
          width: '100%',
          textAlign: 'left'
        }}>
        {textFieldTitle}
      </Typography>
      <Stack
        style={{
          alignItems: navigator.maxTouchPoints > 0 ? 'center' : 'flex-start',
          display: 'flex',
          flexWrap: 'wrap',
          maxHeight: '100%',
          height: '100%'
        }}
      >
        <Stack direction='column' alignItems='flex-start' justifyContent='flex-start'padding={1.5} width='100%' height='100%'>
          <Box sx={style} >
            <Stack
              width='100%'
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={0}
            >
              <>
                <Signature
                  className={`${subitem.itemid}|${subitem.id}`}
                  style={{ display: !assinatura ? '' : 'none', backgroundColor: 'inherit' }}
                  height={200}
                  ref={refAssinatura}
                />
                <div>
                  <img
                    alt=''
                    style={{ display: assinatura ? '' : 'none', margin: 0, padding: 0 }}
                    src={assinatura as string}
                  />
                </div>
              </>
              <Stack
                style={{ width: 'fit-content', height: '100%' }}
                direction="column"
                justifyContent="flex-end"
                alignItems="flex-end"
                spacing={4}
              >
                {!assinatura ? <SaveIcon
                  fontSize='large'
                  sx={{ fontSize: '45px', cursor: 'pointer', ':hover': { color: 'black' } }}
                  color='action'
                  onClick={() => handleSave()}
                /> :
                  <DeleteIcon
                    fontSize='large'
                    sx={{ fontSize: '45px', cursor: 'pointer', ':hover': { color: '#ab003c' } }}
                    color='error'
                    onClick={() => handleClear()}
                  />}
              </Stack>
            </Stack>
          </Box>
        </Stack>
      </Stack >
      {assinatura && <AdditionalInfo subItem={subitem} />}
    </>
  );
}